import { schema } from 'normalizr';

const getAccountGOSAuctions = new schema.Entity('accountGOSAuctions');

export default getAccountGOSAuctions;
